import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ml-3 text-sm text-gray-900" }

import { ref } from 'vue'
import { Switch } from '@headlessui/vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'ToggleSwitch',
  props: {
    value: {
        type: Boolean,
        default: null,
        required: true,
    },
    label: {
        type: String,
    },
},
  emits: ["change"],
  setup(__props) {

const props = __props;



const switchValue = ref(props.value)

// const switchValue = computed<object>({
//     get() {
//         return props.value;
//     },
//     set(value) {
//         emit('change', value);
//     }
// })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "flex items-center cursor-pointer",
    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('change', !__props.value)))
  }, [
    _createVNode(_unref(Switch), {
      modelValue: switchValue.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((switchValue).value = $event)),
      class: _normalizeClass([switchValue.value ? 'bg-primary-500' : 'bg-gray-300', "relative inline-flex h-[20px] w-[32px] shrink-0 cursor-pointer rounded-full transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75"])
    }, {
      default: _withCtx(() => [
        _createElementVNode("span", {
          "aria-hidden": "true",
          class: _normalizeClass([switchValue.value ? 'translate-x-4' : 'translate-x-1', "pointer-events-none inline-block mt-1 h-[12px] w-[12px] transform rounded-full bg-white shadow-lg ring-0 transition duration-200 ease-in-out"])
        }, null, 2)
      ]),
      _: 1
    }, 8, ["modelValue", "class"]),
    _createElementVNode("p", _hoisted_1, _toDisplayString(__props.label), 1)
  ]))
}
}

})